import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { CoursesFacade } from '@app/store/courses';
import { Course } from '@app/store/shared/models';
import { PredefinedPathwayCourseSelectionService } from './course-selection.service';

@Component({
    selector: 'app-predefined-pathway-select-course-dialog',
    templateUrl: './select-course-dialog.component.html',
    styleUrls: ['./select-course-dialog.component.css'],
    imports: [TranslateModule, TableModule],
})
export class SelectCourseDialogComponent implements OnInit, OnDestroy {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly coursesFacade = inject(CoursesFacade);
    private readonly courseSelection = inject(PredefinedPathwayCourseSelectionService);

    readonly items = this.coursesFacade.courses;
    readonly total = this.coursesFacade.total;
    readonly loading = this.coursesFacade.loading;
    readonly limit = 10;

    ngOnInit(): void {
        this.loadCourses();
    }

    ngOnDestroy(): void {
        this.coursesFacade.clear();
    }

    selectCourse(course: Course | Course[] | undefined): void {
        if (!course) {
            return;
        }

        const selected = Array.isArray(course) ? course[0] : course;
        if (selected) {
            this.courseSelection.select({ id: selected.id, name: selected.name });
            this.closePopup();
        }
    }

    onPageChange(event: TableLazyLoadEvent): void {
        const page = Math.floor((event.first ?? 0) / this.limit) + 1;
        this.loadCourses(page);
    }

    loadCourses(page = 1): void {
        this.coursesFacade.getCourses({ page, limit: this.limit });
    }

    private closePopup(): void {
        this.router.navigate([{ outlets: { dialog: null } }], { relativeTo: this.route.parent?.parent });
    }
}
